import { useState } from 'react'
import { useUnit } from 'effector-react'
import { $userToken, addFriendFx, getFullExternalProfileFx, removeFriendFx } from '@/entities/user'

export const useFriendAction = (isFriend: boolean, friendTid: number) => {
  const [isLoading, setIsLoading] = useState(false)
  const userToken = useUnit($userToken)
  const handleFriendAction = async () => {
    try {
      setIsLoading(true)
      if (isFriend) {
        await removeFriendFx({ token: userToken!, friend_tid: friendTid })
      } else {
        await addFriendFx({ token: userToken!, friend_tid: friendTid })
      }
    } finally {
      setIsLoading(false)
      await getFullExternalProfileFx({ token: userToken!, friend_tid: friendTid })
    }
  }

  return {
    handleFriendAction,
    isLoading,
  }
}
